import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { SubscriptionService } from './services/subscription.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'recall-web';

  constructor(
    private translate: TranslateService,
    public router: Router,
    public subService: SubscriptionService
  ) {
    const defaultLang = 'en';
    const supported = ['en', 'it', 'de', 'fr', 'es'];

    translate.addLangs(supported);
    translate.setDefaultLang(defaultLang);

    const browserLang = translate.getBrowserLang();
    const langToUse = (browserLang && supported.includes(browserLang)) ? browserLang : defaultLang;
    translate.use(langToUse);

  }
}
